var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import MuiAppBar from '@mui/material/AppBar';
import { Box, styled, Typography, Toolbar } from '@mui/material';
import { Routes } from '../../routes/constants';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useMemo } from 'react';
import { AuthUtil } from '../../util/auth-util';
var Main = styled('main', { shouldForwardProp: function (prop) { return prop !== 'open'; } })(function (_a) {
    var theme = _a.theme, open = _a.open;
    return (__assign(__assign({ flexGrow: 1, width: '100%', 
        // Make the main area fill the remaining viewport height under the
        // portal header + appbar. This helps ensure children can size to the
        // available space without unexpected wrapping or layout shifts.
        minHeight: 'calc(100vh - var(--portal-header-height, 0px) - var(--appbar-height, 96px))', padding: '0', transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }), marginLeft: 0 }, (open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginLeft: 0
    })), { scrollBehavior: 'smooth' }));
});
export var Layout = function (_a) {
    var children = _a.children;
    var pathname = useLocation().pathname;
    var getRouteHeaderName = function (routes) {
        var headerName = 'INTERMAT - SISTEMA DE GESTÃO FUNDIÁRIA';
        var pathKeys = Object.keys(routes);
        pathKeys.forEach(function (path) {
            var _a;
            var route = routes[path];
            if ((route === null || route === void 0 ? void 0 : route.path) && pathname.includes(route === null || route === void 0 ? void 0 : route.path)) {
                headerName = (_a = route === null || route === void 0 ? void 0 : route.headerName) !== null && _a !== void 0 ? _a : '';
            }
        });
        return headerName;
    };
    var isLocalDevelopment = useMemo(function () {
        return AuthUtil.DEVELOPMENT_LOCAL === 'true';
    }, []);
    var marginTop = useMemo(function () {
        return isLocalDevelopment ? '0em' : '0em';
    }, [isLocalDevelopment]);
    useEffect(function () {
        var computeAppBarHeight = function () {
            var headerEl = document.getElementById('HEADER_NAME');
            var appBar = headerEl === null || headerEl === void 0 ? void 0 : headerEl.closest('.MuiAppBar-root');
            var h = appBar === null || appBar === void 0 ? void 0 : appBar.getBoundingClientRect().height;
            var height = h ? "".concat(Math.round(h), "px") : '96px';
            document.documentElement.style.setProperty('--appbar-height', height);
        };
        var computePortalHeaderHeight = function () {
            var portalHeader = document.querySelector('#mt-cidadao-header') ||
                document.querySelector('header') ||
                null;
            var ownAppBar = document.querySelector('.MuiAppBar-root');
            var isOwnHeader = portalHeader && ownAppBar && portalHeader.contains(ownAppBar);
            var h = !portalHeader || isOwnHeader ? 0 : portalHeader.getBoundingClientRect().height;
            var height = h ? "".concat(Math.round(h), "px") : '0px';
            document.documentElement.style.setProperty('--portal-header-height', height);
        };
        computeAppBarHeight();
        computePortalHeaderHeight();
        window.addEventListener('resize', computeAppBarHeight);
        window.addEventListener('resize', computePortalHeaderHeight);
        return function () {
            window.removeEventListener('resize', computeAppBarHeight);
            window.removeEventListener('resize', computePortalHeaderHeight);
        };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ sx: { display: 'flex', position: 'sticky', top: 0, zIndex: 1100, width: '100%' } }, { children: _jsx(MuiAppBar, __assign({ position: "static", sx: function (theme) { return ({
                        borderRadius: 0,
                        backgroundColor: '#fafafa',
                        color: theme.palette.text.primary,
                        boxShadow: 'none',
                        borderBottom: '1px solid rgba(0,0,0,0.08)',
                        '& .MuiToolbar-root': {
                            justifyContent: 'center',
                            paddingRight: '8px',
                            paddingLeft: '8px',
                            flexWrap: 'nowrap',
                            minHeight: 'auto',
                            width: '100%'
                        },
                    }); }, style: { marginTop: marginTop } }, { children: _jsx(Toolbar, __assign({ sx: {
                            minHeight: 'auto',
                            width: '100%'
                        }, style: {
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: 'auto',
                            paddingTop: 12,
                            paddingBottom: 12,
                        } }, { children: _jsx(Typography, __assign({ sx: {
                                justifyContent: 'center',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: '100%'
                            }, letterSpacing: 0.15, id: "HEADER_NAME", fontWeight: 500, component: "div", noWrap: true, align: "center", margin: "auto", fontSize: 18, variant: "h6" }, { children: getRouteHeaderName(Routes) })) })) })) })), _jsx(Main, __assign({ open: false }, { children: children }))] }));
};
